import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { ToastProvider } from "./components/Toast";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { App } from "./App";
import "./index.css";

/**
 * Uygulama girişi.
 *
 * Sıralama kasıtlıdır:
 *  ErrorBoundary → hata olsa bile beyaz ekran yerine okunabilir panel
 *  BrowserRouter → rota bağlamı
 *  AuthProvider  → onIdTokenChanged; rol değişince menü ANINDA güncellenir
 *  ToastProvider → her ekran gerçek başarı/hata mesajı basabilsin
 */
const container = document.getElementById("root");
if (!container) {
  throw new Error("#root bulunamadı — index.html bozulmuş olabilir.");
}

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary where="Uygulama">
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
